export var THREE_DIMENSION_PROJECTIONS = [
    'orthographic',
    'azimuthalEqualArea',
];
export var NOT_SUPPORT_ROTATION = ['geoAlbersUsa'];
